"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleEditorContainer = exports.StyledContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styleConstants = require("@widget-editor/shared/lib/styles/style-constants");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledContainer",
  componentId: "sc-1fm4mu4-0"
})(["width:100%;height:100%;min-height:740px;", ""], function (props) {
  return props.isCompact || props.forceCompact ? (0, _styledComponents.css)(["box-sizing:border-box;position:relative;margin:0 auto;height:calc(100% - ", ");"], _styleConstants.FOOTER_HEIGHT) : (0, _styledComponents.css)(["display:flex;flex-flow:wrap;justify-content:space-between;flex-flow:column;@media only screen and (min-width:768px){flex-flow:wrap;}"]);
});

exports.StyledContainer = StyledContainer;

var StyleEditorContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyleEditorContainer",
  componentId: "sc-1fm4mu4-1"
})(["display:flex;width:100%;height:660px;"]);

exports.StyleEditorContainer = StyleEditorContainer;